export const GET_UNITS_REQUEST = 'GET_UNITS_REQUEST';
export const GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS';
export const GET_UNITS_FAILURE = 'GET_UNITS_FAILURE';
export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';
export const SET_IS_MENU_ACTIVE = 'SET_IS_MENU_ACTIVE';
export const SET_HEADER_STICKY_MENU_SHOWN = 'SET_HEADER_STICKY_MENU_SHOWN';
export const SET_HEADER_SEARCH_SHOWN = 'SET_HEADER_SEARCH_SHOWN';
export const SET_PAGE_LEVEL_NAVIGATION_STICKY_MENU_SHOWN = 'SET_PAGE_LEVEL_NAVIGATION_STICKY_MENU_SHOWN';
export const SET_COMPARE_PRODUCTS_STICKY_MENU_SHOWN = 'SET_COMPARE_PRODUCTS_STICKY_MENU_SHOWN';
export const SET_LOCATION_MISMATCH_BAR_OPEN = 'SET_LOCATION_MISMATCH_BAR_OPEN';
